export default __webpack_public_path__ + "static/media/php.8c49448b.svg";